export interface BannerSlide {
  id: string;
  videoId: string;
  title: string;
  tagline: string;
  tag: string;
  image: string;
}

export const bannerSlides: BannerSlide[] = [
  {
    id: 'b1',
    videoId: 'v007',
    title: '风起云岚',
    tagline: '少年将军执兵符入局，于权谋棋局中步步为营，还天下朗朗乾坤。',
    tag: '热播古装',
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20epic%20ancient%20chinese%20palace%20courtyard%20at%20dusk%20with%20flowing%20golden%20banners%20and%20misty%20mountains%20behind%2C%20dramatic%20warm%20lighting%2C%20moody%20film%20still%20atmosphere%2C%20high%20detail&width=1600&height=700&seq=mock-banner-001&orientation=landscape',
  },
  {
    id: 'b2',
    videoId: 'v001',
    title: '星海远征',
    tagline: '面对未知的宇宙震荡与人性抉择，他们必须决定星海的去向。',
    tag: '科幻巨制',
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20deep%20space%20scene%20with%20a%20massive%20glowing%20planet%20and%20a%20small%20spaceship%20silhouette%2C%20vast%20starfield%20nebula%2C%20dramatic%20cosmic%20lighting%2C%20film%20still%20atmosphere%2C%20high%20detail&width=1600&height=700&seq=mock-banner-002&orientation=landscape',
  },
  {
    id: 'b3',
    videoId: 'v009',
    title: '谜城档案',
    tagline: '每一宗案件背后，都藏着一座城不为人知的秘密。',
    tag: '悬疑烧脑',
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20dark%20crime%20investigation%20room%20with%20case%20files%20and%20clue%20photos%20on%20a%20wall%2C%20teal%20and%20amber%20moody%20lighting%2C%20film%20still%20atmosphere%2C%20high%20detail&width=1600&height=700&seq=mock-banner-003&orientation=landscape',
  },
  {
    id: 'b4',
    videoId: 'v013',
    title: '欢乐总动员',
    tagline: '爆笑游戏与高能反转轮番上演，每一期都笑到停不下来。',
    tag: '人气综艺',
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20vibrant%20tv%20variety%20show%20stage%20with%20colorful%20stage%20lights%20and%20confetti%2C%20friendly%20joyful%20atmosphere%2C%20warm%20orange%20and%20teal%20tones%2C%20film%20still%20atmosphere%2C%20high%20detail&width=1600&height=700&seq=mock-banner-004&orientation=landscape',
  },
  {
    id: 'b5',
    videoId: 'v004',
    title: '极速突围',
    tagline: '每一条隧道都是陷阱，每一次提速都在赌命。',
    tag: '动作爽片',
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20night%20city%20highway%20with%20a%20muscle%20car%20racing%20through%20motion%20blur%2C%20orange%20street%20lights%20and%20speed%20streaks%2C%20gritty%20film%20still%20atmosphere%2C%20high%20detail&width=1600&height=700&seq=mock-banner-005&orientation=landscape',
  },
];